import React, { useState, useEffect } from 'react';
import './Input.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  maxLength?: number;
  showCharCount?: boolean;
}

const Input: React.FC<InputProps> = ({ 
  error, 
  className = '', 
  type, 
  maxLength,
  showCharCount = false,
  value,
  onChange,
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const isPassword = type === 'password';

  const inputType = isPassword && showPassword ? 'text' : type;

  useEffect(() => {
    if (value !== undefined) {
      setCharCount(String(value).length);
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    // Limitar a maxLength si está definido
    if (maxLength && newValue.length > maxLength) {
      newValue = newValue.substring(0, maxLength);
      // Crear un nuevo evento con el valor truncado
      const syntheticEvent = {
        ...e,
        target: { ...e.target, value: newValue }
      } as React.ChangeEvent<HTMLInputElement>;
      setCharCount(newValue.length);
      if (onChange) {
        onChange(syntheticEvent);
      }
      return;
    }
    setCharCount(newValue.length);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={`input-wrapper ${isPassword ? 'input-wrapper-password' : ''} ${showCharCount ? 'input-wrapper-char-count' : ''}`}>
      <input
        className={`form-input ${error ? 'error' : ''} ${className}`}
        type={inputType}
        value={value}
        onChange={handleChange}
        maxLength={maxLength}
        {...props}
      />
      {isPassword && (
        <button
          type="button"
          className="password-toggle"
          onClick={() => setShowPassword(!showPassword)}
          aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        >
          {showPassword ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
              <line x1="1" y1="1" x2="23" y2="23"></line>
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          )}
        </button>
      )}
      {showCharCount && maxLength && (
        <div className="char-count">
          {charCount}/{maxLength}
        </div>
      )}
    </div>
  );
};

export default Input;
